import { ApiCore } from '@/services/api/utils/core.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'
import { apiProvider } from '@/services/api/utils/provider.js'

const url = `v1/profile`
const plural = 'v1/profiles'
const single = 'v1/profile'

const api = new ApiCore({
	index: true,
	findOne: true,
	url: url,
	plural: plural,
	single: single
})

api.getProfile = (id) => {
	return axios
		.get(`${apiProvider.BASE_URL}/v1/profile/${id}`)
		.then(handleResponse)
		.catch(handleError);
}

export default api
